import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import './index.scss';
import LinearGradient from '@hfe/max-linear-gradient';
function UnJoinedActivityBanner(props) {
    const { onClickJoinButton, feConfig } = props;
    const { styleConfig } = feConfig ?? {};
    return <View className="activity-banner" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
      <LinearGradient className="activity-banner__background" colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }}/>
      <View className="activity-banner__content">
        <Image source={{
        uri: 'https://img.meituan.net/makerjiulv/2b520c40fcba2cb3454330699420138c11987.png'
    }} className="activity-banner__icon"/>
        <Text className="activity-banner__text">抽取心动城市赢免单</Text>
      </View>
      <Button className="activity-banner__button" onPress={() => {
        onClickJoinButton();
    }}>
        <Text className="activity-banner__button-text">去看看</Text>
      </Button>
    </View>;
}
export default memo(UnJoinedActivityBanner);
